export default __webpack_public_path__ + "static/imageSP-9f53e697c6953cea1678cb14ef607999.svg";